/**
 * Copyright © 2025-2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Outlet, RouteObject } from "react-router-dom";

import { ProtectedRoute } from "../../components/AppRouter/ProtectedRoute";
import Orders from "../../pages/Orders";
import { HOME_ROUTE } from "../../util/routing";

import { ORDER_DETAIL_ROUTE, ORDERS_ROUTES } from "./constants";
import OrderDetails from "./OrderDetails";

export const ordersRoutes: RouteObject[] = [
  {
    element: (
      <ProtectedRoute mode="single" permission="Orders_OrderView" redirectTo={HOME_ROUTE}>
        <Outlet />
      </ProtectedRoute>
    ),
    children: [
      { path: ORDERS_ROUTES.BASE, element: <Orders /> },
      { path: ORDER_DETAIL_ROUTE, element: <OrderDetails /> },
    ],
  },
];
